function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M12 2C6.48 2 2 6.15 2 11.26c0 2.9 1.44 5.48 3.68 7.18v1.85c0 .77.82 1.25 1.49.87l1.86-1.05c.94.27 1.93.41 2.96.41 5.52 0 10-4.15 10-9.26C22 6.15 17.52 2 12 2zm3.51 8.44l-2.5 2.99c-.16.19-.42.23-.63.11l-1.01-.59a.523.523 0 00-.37-.05l-2.01.49a.502.502 0 01-.5-.81l2.54-3.02c.15-.18.41-.23.62-.12l1.18.62a.5.5 0 00.36.04l1.82-.47c.46-.12.81.44.5.81z"
})));